import Vue from 'vue'
import Router from 'vue-router'
import Header from "@/components/Header";
import Home from '@/view/Home'
import Login from '@/view/Login'
import Fuwu from '@/view/Fuwu/Fuwu'
import Fuwuxiang from '@/view/Fuwu/Fuwuxiang'
import Dingdan from '@/view/Dingdan/Dingdan'
import Yufu from '@/view/Dingdan/Yufu'
import Yuwuzhong from '@/view/Dingdan/Yuwuzhong'
import Wangjie from '@/view/Dingdan/Wangjie'
import Geren from '@/view/Geren/Geren'
import Dingdang from '@/view/Geren/Dingdang'
import Zhinang from '@/view/Geren/Zhinang'
import Zhinangliebiao from '@/view/Geren/Zhinangliebiao'
import Tiwen from '@/view/Geren/Tiwen'
import Guanyu from '@/view/Guanyu/Guanyu'
import Zixun from '@/view/Guanyu/Zixun'
import Jiejue from '@/view/Jiejue/Jiejue'
import Fuwushang from '@/view/Jiejue/Fuwushang'
import Zhengfu from '@/view/Jiejue/Zhengfu'
import Waibao from '@/view/Jiejue/Waibao'
import Shanghuiruzha from '@/view/Jiejue/Shanghuiruzha'
import Faqihetong from '@/view/Dingdan/Faqihetong'
import Zhengwu from '@/view/Zhengwu/Zhengwu'
import Zhitongche from '@/view/Zhengwu/Zhitongche'
import Zhengwujigou from '@/view/Zhengwu/Zhengwujigou'
import Zhinan from '@/view/Zhengwu/Zhinan'
import Shanhui from '@/view/Zhengwu/Shanhui'
import Shanhuiming from '@/view/Zhengwu/Shanhuiming'
import Guanyupingtai from '@/view/Zhengwu/Guanyupingtai'
import Advice from '@/view/Zhengwu/Advice'
import Hezuo from '@/view/jiejue/Hezuo'
import Business from '@/view/Zhengwu/Business'
import Article from '@/view/Zhengwu/Article'
import Tiwenliebiao from '@/view/geren/Tiwenliebiao'
import Settled from '@/view/jiejue/Settled'
import Listpage from '@/view/Zhengwu/Listpage'
import Settledone from '@/view/jiejue/Settledone'
import Joinshanhui from '@/view/Zhengwu/Joinshanhui'
import Settledtwo from '@/view/jiejue/Settledtwo'
import Kong from '@/view/Kong'
import Empty from '@/view/Empty'
import Adtitle from '@/view/Zhengwu/Adtitle'
import qyadvice from '@/view/Zhengwu/qyadvice'
import Consultation from '@/view/Zhengwu/Consultation'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/fuwu',
      name: 'fuwu',
      component: Fuwu,
    },
    {
      path: '/fuwuxiang',
      name: 'fuwuxiang',
      component: Fuwuxiang
    },
    {
      path: '/dingdan',
      name: 'dingdan',
      component: Dingdan
    },
    {
      path: '/yufu',
      name: 'yufu',
      component: Yufu
    },
    {
      path: '/geren',
      name: 'geren',
      component: Geren
    },
    {
      path: '/dingdang',
      name: 'dingdang',
      component: Dingdang
    },
    {
      path: '/yuwuzhong',
      name: 'yuwuzhong',
      component: Yuwuzhong
    },
    {
      path: '/wangjie',
      name: 'wangjie',
      component: Wangjie
    },
    {
      path: '/zhinang',
      name: 'zhinang',
      component: Zhinang
    },
    {
      path: '/zhinangliebiao',
      name: 'zhinangliebiao',
      component: Zhinangliebiao
    },
    {
      path: '/guanyu',
      name: 'guanyu',
      component: Guanyu
    },
    {
      path: '/zixun',
      name: 'zixun',
      component: Zixun
    },
    {
      path: '/jiejue',
      name: 'jiejue',
      component: Jiejue
    },
    {
      path: '/fuwushang',
      name: 'fuwushang',
      component: Fuwushang
    },
    {
      path: '/zhengfu',
      name: 'zhengfu',
      component: Zhengfu
    },
    {
      path: '/waibao',
      name: 'waibao',
      component: Waibao
    },
    {
      path: '/shanghuiruzha',
      name: 'shanghuiruzha',
      component: Shanghuiruzha
    },
    {
      path: '/faqihetong',
      name: 'faqihetong',
      component: Faqihetong
    },
    {
      path: '/zhengwu',
      name: 'zhengwu',
      component: Zhengwu
    },
    {
      path: '/zhitongche',
      name: 'zhitongche',
      component: Zhitongche
    },
    {
      path: '/zhengwujigou',
      name: 'zhengwujigou',
      component: Zhengwujigou
    },
    {
      path: '/zhinan',
      name: 'zhinan',
      component: Zhinan
    },
    {
      path: '/shanhui',
      name: 'shanhui',
      component: Shanhui
    },
    {
      path: '/shanhuiming',
      name: 'shanhuiming',
      component: Shanhuiming
    },
    {
      path: '/guanyupingtai',
      name: 'guanyupingtai',
      component: Guanyupingtai
    },
    {
      path: '/tiwen',
      name: 'tiwen',
      component: Tiwen
    },
    {
      path:'/hezuo',
      name:'hezuo',
      component:Hezuo
    },
    {
      path:'/advice',
      name:'advice',
      component:Advice 
    },
    {
      path:'/business',
      name:'business',
      component:Business 
    },
    {
      path:'/article',
      name:'article',
      component:Article 
    },
    {
      path:'/tiwenliebiao',
      name:'tiwenliebiao',
      component:Tiwenliebiao 
    },
    {
      path:'/settled',
      name:'settled',
      component:Settled 
    },
    {
      path:'/listpage',
      name:'listpage',
      component:Listpage 
    },
    {
      path:'/settledone',
      name:'settledone',
      component:Settledone 
    },
    {
      path:'/joinshanhui',
      name:'joinshanhui',
      component:Joinshanhui 
    },
    {
      path:'/settledtwo',
      name:'settledtwo',
      component:Settledtwo 
    },
    {
      path:'/kong',
      name:'kong',
      component:Kong 
    },
    {
      path:'/',
      name:'empty',
      component:Empty ,
    },
    {
      path:'/adtitle',
      name:'adtitle',
      component:Adtitle ,
    },
    {
      path:'/qyadvice',
      name:'qyadvice',
      component:qyadvice ,
    },
    {
      path:'/Consultation',
      name:'Consultation',
      component:Consultation ,
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js